<style>
/*.word-list{
  width: 100%;
}
.word-list.el-table{
  width: 100%;
}
.word-list.el-table .cell{
  padding: 10px 10px;
}
.word-list.el-table .cell button{
  margin-left: 0;
}
.word-list.el-table .el-tooltip__rel , .word-list.el-table .el-tooltip{
  display: inline-block;
}
.word-list.el-table .el-tooltip{
  position: absolute\0;
}
.extend-btn button{
  padding: 6px 7px;
}*/
table{
  width: 100%;
}
.eso-table tr th {
  text-align: left;
  background-color: #EFF2F7;
  border: 1px solid #e0e6ed;
  border-left: 0;
}
.eso-table tr th:first-child{
  border-left: 1px solid #e0e6ed;
}
.eso-table tr th , .eso-table tr td{
  padding: 10px;
}
.eso-table tr td{
  border: 1px solid #e0e6ed;
  border-left: 0;
  border-top: 0;
}
.eso-table tr td:first-child{
  border-left: 1px solid #e0e6ed;
}
.eso-table.stripe tr:nth-child(2n) td{
  background: #fafafa;
}
.eso-table td{
  transition:background-color .25s ease;
}
.eso-table tr:hover>td{
  background-color: #eef1f6;
}
.eso-table td.btn-container button{
  margin-left: 0;
}
.eso-table .btn-tails button{
  padding: 6px 7px;
}
.eso-table .btn-fetch-tails{
  float: right\0;
}
.eso-table i.icon.loading{
  font-size: 16px;
}
.high-seo {
  font-size:16px;
  color: #FF9609;
}
.high-seo>span{
  font-size:14px;
  color: rgb(255, 66, 0);
  display: block;
  float: left;
  margin-top: 1px;
  margin-right: 5px;
}
.more-use {
  color:#FF4200;
  font-size:18px;
}
</style>

<template>
  <div>
    <table class="eso-table stripe" cellspacing="0" cellpadding="0" border="0">
      <colgroup>
        <col >
        <col width="200">
        <col :width="type === 'extend' ? 48 : 125">
      </colgroup>
      <tr>
        <th>关键词</th>
        <th>优化指数</th>
        <th>操作</th>
      </tr>
      <tr v-for="(word ,$index) in wordInfos">
        <td>{{word.keyword}}</td>
        <!--<td><i class="icon loading iconfont icon-gengduo1"></i></td>-->
        <td>
          <span v-show="word.state === 0">
            <i class="el-icon-loading"></i>
          </span>
          <span v-show="word.state === -1">查询失败，请重试</span>
          <span v-show="word.state !== -1 && word.state !==0 && word.sindex < 300">{{word.sindex}}</span>
          <span v-show="word.state !== -1 && word.sindex >= 300" class="high-seo">
            <span>{{word.sindex}}</span>
            <el-tooltip placement="top" content="热门词汇，优化难度极大，建议更换">
              <i class="el-icon-information"></i>
            </el-tooltip>
          </span>
          <span v-show="word.state !== -1 && word.state !==0 && word.disabled && (word.sf >= 10 || word.bz >= 3)" class="more-use">
            <el-tooltip placement="top" content="已超过3家企业优化中，建议更换">
              <i class="iconfont icon-jiagezoushi"></i>
            </el-tooltip>
          </span>
          <!--<<transition  enter-active-class="animated zoomIn">
            <span v-show="word.state !== -1 && word.state !==0">{{word.sindex}}</span>
            <span v-show="word.state !== -1 && word.state !==0 && (word.sf >= 10 || word.bz >= 3)">关键词优化难度过大</span>
          </transition>-->
        </td>
        <td class="btn-container" v-show="type !== 'extend' ">
          <el-button v-show="word.state === 0" type="default" class="btn-block" size="small" :disabled="true">正在载入</el-button>
          <el-button v-show="word.state === -1" type="danger" class="btn-block" size="small" @click="reselect($index)">重新获取</el-button>
          <el-button v-show="word.state === 1" type="default" size="small" @click="addToCart($index)" :disabled="word.disabled">加入列表</el-button>
          <el-button v-show="word.state === 2" type="info" size="small" @click="removeToCart($index)" :disabled="word.disabled">移除列表</el-button>
          <el-tooltip v-show="word.state === 1 || word.state === 2" class="item btn-fetch-tails" effect="dark" content="查看推荐词" placement="top" :disabled="word.notTails">
            <el-button type="primary" icon="search" size="small" @click="fetchExtendWords($index)" :disabled="word.notTails"></el-button>
          </el-tooltip>
        </td>
        <td class="btn-container btn-tails" v-show="type === 'extend' ">
          <el-button v-show="word.state === 0" type="default" class="btn-block" size="small" :disabled="true" icon="more"></el-button>
          <el-tooltip v-show="word.state === -1" class="item" effect="dark" content="加载失败，请点击重新获取" placement="top">
            <el-button v-show="word.state === -1" type="warning" class="btn-block" size="small" icon="more" @click="reselect($index)"></el-button>
          </el-tooltip>
          <el-button v-show="word.state === 1" type="default" size="small" @click="addToCart($index)" icon="plus" :disabled="word.disabled"></el-button>
          <el-button v-show="word.state === 2" type="info" size="small" @click="removeToCart($index)" icon="delete" :disabled="word.disabled"></el-button>
        </td>
      </tr>
    </table>
    <!--<el-table
        :data="wordInfos"
        stripe
        border
        style="width:100%;"
        class="word-list">
        <el-table-column
          prop="keyword"
          :resizable="false"
          label="关键词">
        </el-table-column>
        <el-table-column
          prop="sindex"
          :resizable="false"
          label="优化指数" width="200">
        </el-table-column>
        <el-table-column :resizable="false" label="操作" :width="type === 'extend' ? 49 : 125">
          <template scope="scope">
            <span v-show="type !== 'extend'">
              <el-button v-show="wordInfos[scope.$index].state === 0" type="default" class="btn-block" size="small" :loading="true">正在载入</el-button>
              <el-button v-show="wordInfos[scope.$index].state === -1" type="danger" class="btn-block" size="small" @click="reselect(scope.$index)">重新获取</el-button>
              <el-button v-show="wordInfos[scope.$index].state === 1" type="default" size="small" @click="addToCart(scope.$index)">加入列表</el-button>
              <el-button v-show="wordInfos[scope.$index].state === 2" type="info" size="small" @click="removeToCart(scope.$index)">移除列表</el-button>
              <el-tooltip v-show="wordInfos[scope.$index].state === 1 || wordInfos[scope.$index].state === 2" class="item" effect="dark" content="查看扩展词" placement="top">
                <el-button type="primary" icon="search" size="small" @click="fetchExtendWords(scope.$index)"></el-button>
              </el-tooltip>
            </span>
            <span v-show="type === 'extend'" class="extend-btn">
              <el-button v-show="wordInfos[scope.$index].state === 0" type="default" class="btn-block" size="small" :loading="true"></el-button>
              <el-tooltip v-show="wordInfos[scope.$index].state === -1" class="item" effect="dark" content="加载失败，请点击重新获取" placement="top">
                <el-button v-show="wordInfos[scope.$index].state === -1" type="danger" class="btn-block" size="small" icon="more" @click="reselect(scope.$index)"></el-button>
              </el-tooltip>
              <el-button v-show="wordInfos[scope.$index].state === 1" type="default" size="small" @click="addToCart(scope.$index)" icon="plus"></el-button>
              <el-button v-show="wordInfos[scope.$index].state === 2" type="info" size="small" @click="removeToCart(scope.$index)" icon="delete"></el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>-->
  </div>
</template>

<script>
export default {
  name: 'seoInfos',
  props: {
    wordInfos: [ Array ],
    type: [ String ]
  },
  methods: {
    removeToCart (index) {
      this.$emit('removeToCart', this.wordInfos[index])
    },
    addToCart (index) {
      this.$emit('addToCart', this.wordInfos[index])
    },
    fetchExtendWords (index) {
      this.$emit('fetchExtendWords', this.wordInfos[index].keyword)
    },
    reselect (index) {
      this.$emit('selectInfo', this.wordInfos[index])
    }
  }
}
</script>



// WEBPACK FOOTER //
// infos.vue?f0366b3a